/**
 * Returns the result of the first function in @see `fns` that returns a truthy value for the arguments applied
 * 
 * @param {Function[]} fns to execute in search of a truthy value
 */
export const anyOf = (fns: Function[], ...args) => fns.reduce( (r, fn) => !r ? fn(...args) : r , null);
